import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = {
  class: "card-body",
  style: {"min-height":"250px"}
}
const _hoisted_3 = { class: "row row-cols-5" }

import { ref, onMounted, nextTick, provide } from "vue";
import EditGroupPermissions from "./groupPermissions/EditGroupPermissions.vue";
import SystemService from "../../services/SystemService";

export default /*#__PURE__*/_defineComponent({
  __name: 'GroupPermission',
  setup(__props) {

const isLoading = ref(false);
const showDetail = ref(false);
const data = ref<any>([]);
const groupData = ref<any>([]);
const permissions = ref<any>([]);
provide("groupData", groupData);
provide("permissions", permissions);
const handleDetail = async (item: any) => {
  showDetail.value = false;
  groupData.value = item;
  await nextTick();
  showDetail.value = true;
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.getPermissionRoles();
    const res2 = await SystemService.getPermissions();
    data.value = res.data;
    permissions.value = res2.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col py-4"
            }, [
              _createVNode(_component_el_button, {
                size: "large",
                type: "warning",
                class: "min-w-200px",
                plain: "",
                round: "",
                onClick: ($event: any) => (handleDetail(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name) + " - " + _toDisplayString(item.id), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          }), 128))
        ])
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    (showDetail.value)
      ? (_openBlock(), _createBlock(EditGroupPermissions, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})